import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

const ContentList = ({ filteredData }) => {
  const [linkName, setLinkName] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    titleNameFunc();
  }, []);

  function titleNameFunc() {
    if (typeof window !== "undefined") {
      const path = window.location.pathname;
      const parts = path.split("/");
      const selected = parts[1];
      const title = selected.charAt(0).toUpperCase() + selected.slice(1);
      setLinkName(selected);
    }
  }
  if (filteredData === undefined) return <div></div>;

  return (
    <div>
      <div className="footer-container">
        <div className="footer-link-container">
          <a className="footer-link-title" href="/">
            {t("home.home")}
          </a>
          <p className="footer-link-title">/</p>
          <a className="footer-link-title" href={"/" + linkName}>
            {t("menu.pages")}
          </a>
        </div>

        <div className="title-container">{t("menu.pages")}</div>
      </div>

      <div className="pages-container">
        {filteredData
          .filter((item) => item.slug.indexOf("tr") === -1)
          .map(function (d, idx) {
           
            return (
              <div className="pages-content-container">
                <img
                  className="pages-content-image"
                  src={"/img/other-img/app_icon.png"}
                />
                <p className="pages-content-header">{d.title}</p>

                <p className="pages-content-description">
                  {d.headline}
                </p>
                <a className="pages-content-button-container" href={d.slug}>
                  <p className="pages-content-see-detail">See Detail</p>

                  <img
                    className="pages-content-arrow-image"
                    src={"/img/other-img/arrow_icon.png"}
                  />
                </a>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ContentList;